import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SnackService {
  samePage: string = '';

  constructor(private snackBar: MatSnackBar, private router: Router) {}

  // Pass any message with this snack bar function
  passMessage(message: string, duration?: number, route?: string) {
    this.samePage = this.router.url;

    let snackBarRef = this.snackBar.open(`${message}`, 'OK', {
      duration: duration || 3000,
    });

    snackBarRef.afterOpened().subscribe(() => {
      setTimeout(() => {
        this.router.navigate([route || this.samePage]);
      }, 500);
    })


    return this.snackBar._openedSnackBarRef
      ?.onAction()
      .pipe(tap((_) => this.router.navigate([route || this.samePage])))
      .subscribe();
  }
}
